import { StyleSheet } from '@react-pdf/renderer';

export const generalStyles = StyleSheet.create({
  document: { fontFamily: 'Manrope' },
  wholePage: { fontSize: 10, color: '#616161' },
  // color: '#616161'
  fullPage: { padding: 10 },
  h2: { fontSize: 12, fontWeight: 'semibold', marginBottom: 8, color: '#2E2E2E' },
  h3: { fontSize: 12 },
  strong: { fontWeight: 'bold' },
  p: {
    marginBottom: 8,
  },
  boxWrapper: {
    margin: 8, // general 'margin'
    paddingVertical: 16,
    paddingHorizontal: 8,
    backgroundColor: '#F2F2F2',
    border: '1px solid #d3d3d8',
    borderRadius: 2,
  },
});
